import { Switch as MantineSwitch } from '@mantine/core'
import styled from 'styled-components'

export const Switch = styled(MantineSwitch)`
  ${({ theme }) =>
    `
    --switch-width: 2.75rem;
    --switch-height: 1.5rem;
    --switch-thumb-size: 1.25rem;
    --switch-radius: 9999px;

    .mantine-Switch-track {
      background-color: ${theme.colors.gray90};
      border: none;
    }

    .mantine-Switch-thumb {
      border: none;
    }

    .mantine-Switch-input:checked + .mantine-Switch-track {
      background-color: ${theme.colors.success400};
    }
  `}
`
